import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const line = { hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 1, ease: EASE } } };

export const SplitHeading = ({ lines, className = "", eyebrow, testId }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.15 }}
    variants={{ show: { transition: { staggerChildren: 0.09 } } }}
    data-testid={testId}
  >
    {eyebrow && <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-violet-300">{eyebrow}</p>}
    <h2 className={`font-display uppercase leading-[0.88] text-white ${className}`}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-1">
          <motion.span variants={line} className="block">{l}</motion.span>
        </span>
      ))}
    </h2>
  </motion.div>
);
